import { navigation, titles } from '../../../web/styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		padding: 20,
	},
	meetingContext: {
		marginTop: 10,
	},
	note: {
		maxWidth: 500,
		minWidth: 230,
		padding: 20,
	},
	noteInfo: {
		color: navigation,
		fontSize: 12,
		fontStyle: 'italic',
		padding: '5px 0',
		width: '100%',
	},
	noteTitle: {
		color: titles,
		fontSize: 14,
	},
	readOnlyContent: {
		overflowX: 'auto',
		paddingBottom: 8,
	},
});
